// Copiar código/rastreio do card "pedido em foco" (tela de tickets nova). Spec d03-v01 §8.
// Delegado no document (o card chega por ajax). Feedback: ícone vira check por 1,5 s + aviso para leitor de tela.
// navigator.clipboard só existe em contexto seguro (HTTPS/localhost): fora dele, e em qualquer rejeição (permissão),
// cai em falhar() com instrução de cópia manual (parecer d03 F-2). Não usa .copyClipboardHidden (achado 8).
// Sem preventDefault/stopPropagation.

const VOLTA_MS = 1500;
const MSG_FALHA = 'Não foi possível copiar. Selecione o texto e use Ctrl+C.';

const PedidoCopiar = function () {

    const timers = new WeakMap();   // um timer por botão: clique repetido reinicia

    const icone = (btn, de, para) => {
        const i = btn.querySelector('.ai');
        if (i) { i.classList.remove(de); i.classList.add(para); }
    };

    // title original guardado antes de qualquer troca: a falha muda o title e o sucesso/timeout o devolvem.
    const guardarTitle = (btn) => { if (btn.dataset.titleOriginal === undefined) btn.dataset.titleOriginal = btn.title; };
    const restaurarTitle = (btn) => { if (btn.dataset.titleOriginal !== undefined) btn.title = btn.dataset.titleOriginal; };

    const ok = (btn, aviso) => {
        clearTimeout(timers.get(btn));
        restaurarTitle(btn);
        icone(btn, 'ai-copy', 'ai-check');
        btn.dataset.copiado = '1';
        if (aviso) aviso.textContent = btn.dataset.aviso || '';
        timers.set(btn, setTimeout(() => {
            icone(btn, 'ai-check', 'ai-copy');
            delete btn.dataset.copiado;
            if (aviso) aviso.textContent = '';
        }, VOLTA_MS));
    };

    const falhar = (btn, aviso) => {
        clearTimeout(timers.get(btn));
        guardarTitle(btn);
        if (aviso) aviso.textContent = MSG_FALHA;
        btn.title = MSG_FALHA;
        timers.set(btn, setTimeout(() => {
            restaurarTitle(btn);
            if (aviso && aviso.textContent === MSG_FALHA) aviso.textContent = '';
        }, VOLTA_MS));
    };

    const clicar = (e) => {
        const btn = e.target instanceof Element ? e.target.closest('.tk-ped-copiar') : null;
        if (!btn) return;
        const card = btn.closest('.tk-ped');
        const aviso = card ? card.querySelector('.tk-ped-aviso') : null;
        const valor = btn.dataset.copiar || '';
        if (!valor || !window.isSecureContext || !navigator.clipboard || !navigator.clipboard.writeText) {
            falhar(btn, aviso);
            return;
        }
        navigator.clipboard.writeText(valor).then(() => ok(btn, aviso), () => falhar(btn, aviso));
    };

    return {
        init: function () {
            if (!document.querySelector('.open-ticket-detail')) return;   // só na tela de tickets nova
            document.addEventListener('click', clicar);
        },
    };
}();

module.exports = PedidoCopiar;
